const villaSec1_Object = payload => {
  return {
    type: "villaSec1",
    payload
  };
};

export default villaSec1_Object;
